import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientConsent, UUID } from "@/core/types";

import { getPatientConsents } from "../queryFunctions/getPatientConsents";
import { patientConsentsKeys } from "../keyFactory";

type UsePatientConsentsProps<TData = PatientConsent[]> = {
  patientId: UUID;
  select?: (data: PatientConsent[]) => TData;
};

type PatientConsentsQueryOptions = UseQueryOptions<
  PatientConsent[],
  unknown,
  PatientConsent[],
  ReturnType<typeof patientConsentsKeys.list>
>;

export function usePatientConsents<TData = PatientConsent[]>({
  patientId,
  select,
}: UsePatientConsentsProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

export function optionFactory(patientId: UUID) {
  return {
    enabled: !!patientId,
    queryFn: () => getPatientConsents(patientId),
    queryKey: patientConsentsKeys.list(patientId),
    refetchOnWindowFocus: true,
  } satisfies PatientConsentsQueryOptions;
}
